class ProductNavigation extends HTMLElement {
  itemsArray = []

  constructor () {
    super()

    this.sectionExternalEls = window.BAO.utils.getElements(
      '[data-external-el="product-navigation.section"]'
    )
    this.itemsEl = window.BAO.utils.getElement(
      '[data-el="product-navigation.items"]'
    )
    this.buttonEls = window.BAO.utils.getElements(
      '[data-el="product-navigation.button"]'
    )
    this.chooseSizeButton = window.BAO.utils.getElement(
      '[data-el="product-navigation.choose-size"]'
    )

    this.sectionExternalEls.forEach(section => {
      this.buildItems(section.dataset.productNavigationTitle)
    })

    this.buttonEls.forEach(button => {
      button.addEventListener('click', this.onClick.bind(this))
    })

    if (this.chooseSizeButton !== null) {
      this.chooseSizeButton.addEventListener(
        'click',
        this.chooseSize.bind(this)
      )
    }
  }

  buildItems (link) {
    if (!this.itemsArray.includes(link.toLowerCase())) {
      this.itemsArray.push(link.toLowerCase())

      const item = document.createElement('li')
      item.classList.add('prd-Navigation_Item')

      const button = document.createElement('button')
      button.classList.add('prd-Navigation_Link', 'fz-12_18')
      button.setAttribute('data-el', 'product-navigation.button')
      button.appendChild(document.createTextNode(link))

      item.appendChild(button)

      this.itemsEl.appendChild(item)

      this.buttonEls = window.BAO.utils.getElements(
        '[data-el="product-navigation.button"]'
      )

      this.observeItems()
    }
  }

  observeItems () {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.7,
    }

    function observerCallback (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const navItem = Array.from(
            document.querySelectorAll('[data-el="product-navigation.button"]')
          ).find(
            el => el.textContent === entry.target.dataset.productNavigationTitle
          )

          navItem.classList.add('prd-Navigation_Link-active')
          document
            .querySelectorAll('[data-el="product-navigation.button"]')
            .forEach(item => {
              if (item !== navItem) {
                item.classList.remove('prd-Navigation_Link-active')
              }
            })
        }
      })
    }

    // eslint-disable-next-line compat/compat
    const observer = new IntersectionObserver(observerCallback, observerOptions)

    this.sectionExternalEls.forEach(sec => observer.observe(sec))
  }

  onClick (e) {
    window.scrollTo({
      top:
        window.BAO.utils.getOffsetTop(
          window.BAO.utils.getElement(
            `[data-product-navigation-title="${e.target.firstChild.nodeValue}"]`
          )
        ) - 165,
      left: 0,
      behavior: 'smooth',
    })
  }

  chooseSize () {
    window.scrollTo({
      top: window.BAO.utils.getOffsetTop(
        window.BAO.utils.getElement(
          `[data-product-navigation-title="Overview"]`
        )
      ),
      left: 0,
      behavior: 'smooth',
    })
  }
}

customElements.define('product-navigation', ProductNavigation)
